import { Query } from 'acast-reactor';
import request from 'superagent';
import { getUserToken } from 'services/authentication';
import Config from 'app/config';

export default Query.define('userprofile/update', profile => {
  const sanitizedProfile = { ...profile };

  /**
   * In create v1 we would only send delta updates so these values
   * would never be sent, however we now send complete objects so
   * we must strip these out as they are modified/appended by the API
   * before returning the object to us and thus not compatible.
   *
   * These should never be sent from the client anyway and will today
   * generate a 500 on the server, however we should ensure that we
   * sanitize our object there as well.
   *
   * @edvinbesic
   * @todo Ensure server sanitizes before applying updates.
   */
  delete sanitizedProfile.groups;
  delete sanitizedProfile.permissions;
  delete sanitizedProfile.global;

  return new Promise((resolve, reject) => {
    request
      .patch(`${Config.get('CREATE_API_HOST')}/api-v2/user/profile`)
      .send(sanitizedProfile)
      .set('Authorization', `Bearer ${getUserToken()}`)
      .end((err, res) => {
        if (err) {
          reject(err);
        } else {
          resolve(res.body);
        }
      });
  });
});
